<div id="loading-bar-spinner" *ngIf="!alert">
  <i *ngIf="glyph" class="glyphicon {{glyph}} {{status}} {{size}} {{glyphClass}}"></i>
  <div [ngClass]="{'spinner_position': spinnerPosition }" *ngIf="!glyph" class="spinner-icon {{status}} {{size}}"></div>
</div>

<div [ngClass]="alert ? 'alert ' + alert : ''">

    <h4 [ngSwitch]="text" class="{{alert ? 'mb-0 h5' : status}} {{size}}">
      <span *ngSwitchCase="'PRODUCTS'">Loading Products</span>
      <span *ngSwitchCase="'LDG'">Loading</span>
      <span *ngSwitchCase="'LDGMRQ'">Loading Marques</span>
      <span *ngSwitchCase="'LDGVEH'">Loading Vehicles</span>
      <span *ngSwitchCase="'LDGFAM'">Loading Families</span>
      <span *ngSwitchCase="'LDGMOD'">Loading Models</span>
      <span *ngSwitchCase="'LDGCATS'">Loading Categories</span>
      <span *ngSwitchCase="'LDGCAT'">Loading Category</span>
      <span *ngSwitchCase="'ERRLDGCAT'">Error Loading Category</span>
      <span *ngSwitchCase="'LDGSEC'">Loading Section</span>
      <span *ngSwitchCase="'LDGSUB'">Loading Sub Section</span>
      <span *ngSwitchCase="'FDG'">Finding Products</span>
      <span *ngSwitchCase="'SYN'">Syncronising</span>
      <span *ngSwitchCase="'ERR'">An error occured</span>
      <span *ngSwitchCase="'TRANSLATIONS'">Loading Translations</span>
      <span *ngSwitchCase="'LDGNODES'">Loading assembly nodes</span>
      <span *ngSwitchCase="'SVGNODES'">Saving assembly nodes</span>
      <span *ngSwitchCase="'NODESSVD'">Assembly nodes saved</span>
      <span *ngSwitchCase="'NODEERR'">Error loading assembly nodes</span>
      <span *ngSwitchCase="'NODESAVERR'">Error saving assembly nodes</span>
      <span *ngSwitchCase="'LDGILLLINKS'">Loading illustration links</span>
      <span *ngSwitchCase="'SVGILLLINKS'">Saving illustration links</span>
      <span *ngSwitchCase="'SVDILLLINKS'">Saved illustration links</span>
      <span *ngSwitchCase="'DISCARD'">Discarding Changes</span>
      <span *ngSwitchCase="'CHGSDISCARDED'">Changes discarded</span>
      <span *ngSwitchCase="'LDGAPPPATHS'">Loading application paths</span>
      <span *ngSwitchCase="'SVGAPPPATHS'">Saving application paths</span>
      <span *ngSwitchCase="'SVDAPPPATHS'">Saved application paths</span>
      <span *ngSwitchCase="'CASSEMBLIES'">Load Clone Assembly</span>

      <!--following are just leftover from web - delete if not needed-->
      <span *ngSwitchCase="'OFF'">Content unavailable offline.</span>
      <span *ngSwitchCase="'ERRTRY'">An error occured. Please try again.</span>
      <span *ngSwitchCase="'ERRBSKT'">An Error Occured Updating Basket</span>
      <span *ngSwitchCase="'ERRPRTDTLS'">Error loading part details</span>
      <span *ngSwitchCase="'UPTD'">Updated</span>
      <span *ngSwitchCase="'UPTGQTY'">Updating Quantity</span>
      <span *ngSwitchCase="'UPTG'">Updating</span>
      <span *ngSwitchCase="'SVG'">Saving</span>
      <span *ngSwitchCase="'SVD'">Saved</span>
      <span *ngSwitchCase="'TKS'">Thank You</span>
      <span *ngSwitchCase="'DLTG'">Deleting</span>
      <span *ngSwitchCase="'DLTD'">Deleted</span>
      <span *ngSwitchCase="'ACCOPTD'">Thanks for opting to create an account.</span>
      <span *ngSwitchCase="'SGNIN'">Signing In</span>
      <span *ngSwitchCase="'SGNNEW'">Signing into your new account</span>
      <span *ngSwitchCase="'SGNINS'">You have successfully been signed in.</span>
      <span *ngSwitchCase="'SGNFLD'">Log In Failed</span>
      <span *ngSwitchCase="'CALBSKT'">Calculating Basket Totals</span>
      <span *ngSwitchCase="'PLCGODR'">Placing Order</span>
      <span *ngSwitchCase="'WTODRCON'">Please wait for order confirmation.</span>
      <span *ngSwitchCase="'RBTVER'">We could not verify you are not a robot.</span>
      <span *ngSwitchCase="'RBTINST'">Please try again making sure to complete the 'I'm not a robot' box.</span>
      <span *ngSwitchCase="'VERADRS'">Verifying Address</span>
      <span *ngSwitchCase="'VERCDT'">Verifying Card Details</span>
      <span *ngSwitchCase="'ACCLDG'">Creating Account</span>
      <span *ngSwitchCase="'WAIT'">Please Wait</span>
      <span *ngSwitchCase="'ACCREG'">Thank You. Registration and Sign In Successful.</span>
      <span *ngSwitchCase="'ACCCTD'">Account Created</span>
      <span *ngSwitchCase="'ACCERRODROK'">An error occured creating your account. Your order has NOT been affected.</span>
      <span *ngSwitchCase="'QOTAPG'">Approving Quote</span>
      <span *ngSwitchCase="'QOTRJG'">Rejecting Quote</span>
      <span *ngSwitchCase="'QOTAPD'">Quote Approved</span>
      <span *ngSwitchCase="'QOTRJD'">Quote Rejected</span>
      <span *ngSwitchCase="'BSKTEXP'">Basket Item older than 7 days</span>
      <span *ngSwitchCase="'BSKTOOS'">Basket Item Out of Stock</span>
      <span *ngSwitchCase="'USREXST'">User already exists.</span>
      <span *ngSwitchCase="'NOORDOPN'">You don't have any open orders at the moment.</span>
      <span *ngSwitchCase="'NOORDCLSD'">You don't have any closed orders at the moment.</span>
      <span *ngSwitchCase="'NOORD'">You don't have any orders at the moment.</span>
      <span *ngSwitchCase="'EMCOMG'">Confirming Email Address</span>
      <span *ngSwitchCase="'EMCOMD'">Email Address Confirmed</span>
      <span *ngSwitchCase="'EMVERG'">Verifying Email Address</span>
      <span *ngSwitchCase="'EMVERD'">Email Address Verified</span>
      <span *ngSwitchCase="'EMVERF'">Could Not Verify Email Address</span>
      <span *ngSwitchCase="'EMVERS'">Resend Verification Email</span>
      <span *ngSwitchCase="'PNF'">Part Not Found</span>
      <span *ngSwitchCase="'NPF'">No products found</span>
      <span *ngSwitchCase="'SESEX'">Your session has expired. Please sign back in...</span>
      <span *ngSwitchCase="'CUSNF'">Customer not found</span>
      <span *ngSwitchCase="'EMVERPAST'">Email Address already Verified</span>
      <span *ngSwitchCase="'EMINV'">Invalid Email Address</span>
      <span *ngSwitchCase="'VEREML'">Sending Verification Email</span>
      <span *ngSwitchCase="'EMLS'">Email Sent</span>
      <span *ngSwitchCase="'LDGPRD'">Loading Products</span>
      <span *ngSwitchCase="'LDGASS'">Loading Assemblies</span>
      <span *ngSwitchCase="'ENQSNG'">Sending Your Enquiry</span>
      <span *ngSwitchCase="'REPSNG'">Sending Your Error Report</span>
      <span *ngSwitchCase="'NODL'">No download items found</span>
      <span *ngSwitchCase="'NOADD'">No addresses found that match your search terms.</span>
      <span *ngSwitchCase="'USRINV'">Current username does not match your account.</span>
      <span *ngSwitchCase="'EMLPASSR'">Sending Password Reset Email</span>
      <span *ngSwitchCase="'EMNF'">Email Address Not Found</span>
      <span *ngSwitchCase="'EMVERF'">Unable to send verification email</span>
      <span *ngSwitchCase="'EMVERRES'">Click the 'Resend Verification Email' button to try again.</span>
      <span *ngSwitchCase="'TWO'">No tweets found</span>
      <span *ngSwitchCase="'SRCHG'">Searching</span>
      <span *ngSwitchCase="'BSKTCHECK'">Checking Basket Items Availability</span>
      <span *ngSwitchCase="'LDGASSE'">Loading Assembly</span>
      <span *ngSwitchCase="'LDGILL'">Loading Illustration</span>
      <span *ngSwitchCase="'NOINV'">You don't have any invoices at the moment.</span>
      <span *ngSwitchCase="'INVDWN'">Downloading invoice</span>
      <span *ngSwitchCase="'INVDWNCOM'">Invoice downloaded</span>
      <span *ngSwitchCase="'NOCRED'">You don't have any credits at the moment.</span>
      <span *ngSwitchCase="'ASSUNILL'">Assembly Not Illustrated</span>
      <span *ngSwitchCase="'LDGALT'">Loading Alternatives</span>
      <span *ngSwitchCase="'BISALRTUNSUBLDG'">Unsubscribing</span>
      <span *ngSwitchCase="'BISALRTUNSUBSUC'">You have been unsubscribed</span>
      <span *ngSwitchCase="'BSKTUPTD'">Basket Successfully Updated</span>
      <span *ngSwitchCase="'BSKTITEMREM'">Item removed from basket</span>
      <span *ngSwitchCase="'BSKTITEMUPD'">Item successfully updated</span>
      <span *ngSwitchCase="'IMPFILESIZE'">The file is too large.</span>
      <span *ngSwitchCase="'ERRIMP'">An Error Occurred Importing Products</span>
      <span *ngSwitchCase="'PFOUND'">Product Found!</span>
      <span *ngSwitchCase="'INVALIDFORMAT'">Invalid Format</span>
      <span *ngSwitchCase="'FFMREQLDG'">Sending Fitting Quote Request</span>
      <span *ngSwitchCase="'FFMNPA'">No local Fitting Partners available</span>
      <span *ngSwitchCase="'FFMUKONLY'">Fit For Me is only available for UK orders</span>
      <span *ngSwitchCase="'FFMNOPRD'">No products eligible for Fit For Me</span> 
      <span *ngSwitchCase="'FFMDELREQ'">Delivery Address Required</span> 
      <span *ngSwitchCase="'FEEDTHKS'">Thanks for your feedback</span> 
      <span *ngSwitchCase="'FFMPTRERR'">Error loading fitting partner</span> 
      <span *ngSwitchCase="'CUSTEXISTS'">You already have an SNG Barratt account. Please sign in to continue.</span> 
      <span *ngSwitchCase="'FFMPTR404'">Fitting Partner Not Found.</span> 
      <span *ngSwitchCase="'STOPSUB'">Stopping Subscription</span> 
      <span *ngSwitchCase="'STARTSUB'">Starting Subscription</span> 
      <span *ngSwitchCase="'SUBSTOPPED'">Subscription has been stopped</span> 
      <span *ngSwitchCase="'SUBSTOPERR'">An Error Occured - Your subscription has NOT been stopped</span> 
      <span *ngSwitchCase="'FFMFOLUP404'">No Outstanding Fitting Quote Requests Found</span> 
      <span *ngSwitchCase="'FFMORDER404'">Order Not Found</span> 
      <span *ngSwitchCase="'FFMINELLIGIBLE'">Sorry, your address is not elligible for Fit For Me</span> 
      <span *ngSwitchCase="'RECALSHIP'">Recalculating shipping quotes</span> 
      <span *ngSwitchCase="'LDGEXPRESSCHECKOUT'">Loading your details</span> 
      <span *ngSwitchCase="'LDGSHIPQUOTES'">Calculating delivery quotes</span> 
      <span *ngSwitchDefault>{{text}}</span>
  </h4>

    <p *ngIf="desc" class="{{size}} mb-0">
      
      <small>
        <ng-container [ngSwitch]="desc">
          <span *ngSwitchCase="'TRY'">Please try again.</span>
          <span *ngSwitchCase="'TRYLTR'">Please try again later.</span>
          <span *ngSwitchCase="'OFF'">Please check your connection and try again.</span>
          <span *ngSwitchCase="'BSKTKEEP'">Would you like to keep this item in your basket?</span>
          <span *ngSwitchCase="'BSKTUPDT'">This item has been amended with up-to-date details for this product.</span>
          <span *ngSwitchCase="'BSKTOOS'">This item can still be ordered - but delivery times may vary.</span>
          <span *ngSwitchCase="'USREXST'">You opted to create a new account but the email provided already exists. Login next time for faster checkout.</span>
          <span *ngSwitchCase="'TKS'">Thank You</span>
          <span *ngSwitchCase="'EMVERR'">Request another verifaction email below and try again.</span>
          <span *ngSwitchCase="'PNF'">Whoops! We couldn't find the part your were looking for.</span>
          <span *ngSwitchCase="'NPF'">Try a different category or use fewer filters to broaden the search range.</span>
          <span *ngSwitchCase="'EMVERINV'">We could not verify this email address as this customer can not be found. Request a new verifaction email below and try again.</span>
          <span *ngSwitchCase="'SYN'">It looks like you have added items to your basket whilst not logged in or on another device. Please wait while we syncronise these items with your account basket.</span>
          <span *ngSwitchCase="'INTCH'">A member of our team will be in touch shortly.</span>
          <span *ngSwitchCase="'INBOX'">Please check your inbox aswell as spam/junk folders, and follow the instructions in the email.</span>
          <span *ngSwitchCase="'INBOXVER'">An email has been sent with instructions to verify your email address. Click here to continue.</span>
          <span *ngSwitchCase="'ACCS'">Your account has been created but signing in failed. Click here to try again.</span>
          <span *ngSwitchCase="'WAIT'">Please Wait</span>
          <span *ngSwitchCase="'EMNF'">We couldn't find an account associated with that username/email address.</span>
          <span *ngSwitchCase="'EMVERRES'">Click the 'Resend Verification Email' button to try again.</span>
          <span *ngSwitchCase="'SGNIN'">You have successfully been signed in.</span>
          <span *ngSwitchCase="'SGNFLD'">The username/email address or password is incorrect. Please try again.</span>
          <span *ngSwitchCase="'CLKTRY'">Please click here and try again.</span>
          <span *ngSwitchCase="'BSKTREM'">This product will be automatically removed from your basket.</span>
          <span *ngSwitchCase="'RBTINST'">Please try again making sure to complete the 'I'm not a robot' box.</span>
          <span *ngSwitchCase="'WTODRCON'">Please wait for order confirmation.</span>
          <span *ngSwitchCase="'HPPJSON'">Unable to retrieve transaction data for this order.</span>
          <span *ngSwitchCase="'HPPERR'">Unable to initialize payment provider.</span>
          <span *ngSwitchCase="'IMPEMPTY'">Unable to import an empty list of parts.</span>
          <span *ngSwitchCase="'IMPPNF'">Whoops! We couldn't find the parts your were looking for.</span>
          <span *ngSwitchCase="'IMPLIMIT'">You are trying to import too many products. Please reduce the list and try again.</span>
          <span *ngSwitchCase="'IMPFILESIZEDESC'">Please reduce the file size and try again.</span>
          <span *ngSwitchCase="'FFMNPA'">Sorry, we do not have any Fitting Partners available in your area.</span>
          <span *ngSwitchCase="'FFMUKONLY'">Sorry, our Fit For Me service is currently only available in the UK.</span>
          <span *ngSwitchCase="'FFMNOPRD'">The products on the associated order are not eligible for our Fit For Me service.</span>
          <span *ngSwitchCase="'INVALIDFORMAT'">Please ensure you format the data correctly.</span>
          <span *ngSwitchCase="'FFMDELREQ'">The associated order does not contain a delivery address - local fitting partners cannot be found.</span> 
          <span *ngSwitchCase="'SUBSTOPPED'">You will now be redirected back to your Fit For Me homepage</span> 
          <span *ngSwitchCase="'LIVECHAT'"><button class="btn btn-sm btn-secondary">Click here</button> to live chat with a customer service agent.</span> 
          <span *ngSwitchCase="'FFMFOLUP404'">We couldn't find any outstanding Fitting Quote Requests for this order. Have already given your feedback for this order? <br> If not <button class="btn btn-sm btn-secondary">Click here</button> to chat with a customer service agent and let us know which garages have not supplied a Fitting Quote.</span> 
          <span *ngSwitchCase="'FFMORDER404'">We couldn't find this order and therefore could not display the related Fitting Quote Requests.<br><button class="btn btn-sm btn-secondary">Click here</button> to chat with a customer service agent and let us know which garages have not supplied a Fitting Quote.</span> 
          <span *ngSwitchCase="'FFMPTRFOL'">Our customer service team will reach out to any garages that have not supplied a quote.</span> 
          <span *ngSwitchCase="'FFMINELLIGIBLE'">Fit For Me is currently only available for garages within the UK.<br> Shown this message in error? <button class="btn btn-sm btn-secondary">Click here</button> to chat with a customer service agent</span> 
          <span *ngSwitchCase="'BSKTCHECKWHILE'">Please wait. This may take a while if you have lots of basket items.</span> 
          <span *ngSwitchCase="'LDGBILLINGADDRESS'">Checking your billing address</span> 
          <span *ngSwitchCase="'LDGSHIPPINGADDRESS'">Finding your default shipping address</span> 
          <span *ngSwitchDefault>{{desc}}</span>
        </ng-container>
      </small>
    </p>

</div>

<!--button ng-if="status == 'red' &amp;&amp; failFn" ng-click="failFn()" class="btn btn-default" style="margin-top: 8px;">{{failFnText ? failFnText : 'Click here to Try Again'}}</button-->
